// Runtime config is loaded before the app bundle; an explicit empty API_BASE_URL means
// "use same-origin /api" and must override Vite's build-time fallback.
export function resolveApiBaseUrl(): string {
  const runtimeConfig = typeof window !== 'undefined'
    ? (window as any).runtimeConfig
    : undefined

  if (runtimeConfig && Object.prototype.hasOwnProperty.call(runtimeConfig, 'API_BASE_URL')) {
    return runtimeConfig.API_BASE_URL || ''
  }

  return import.meta.env.VITE_API_BASE_URL || ''
}
